import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const NotificacionesContext = createContext();

const STORAGE_KEY = 'agorax_notificaciones';

const cargarNotificaciones = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch {
    return [];
  }
};

const guardarNotificaciones = (notifs) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notifs.slice(0, 50)));
  } catch {}
};

export const NotificacionesProvider = ({ children }) => {
  const [notificaciones, setNotificaciones] = useState(cargarNotificaciones);
  const [ultimoVisto, setUltimoVisto] = useState(() => {
    try {
      return parseInt(localStorage.getItem('agorax_notif_visto') || '0', 10);
    } catch {
      return 0;
    }
  });

  useEffect(() => {
    guardarNotificaciones(notificaciones);
  }, [notificaciones]);

  useEffect(() => {
    localStorage.setItem('agorax_notif_visto', String(ultimoVisto));
  }, [ultimoVisto]);

  const agregarNotificacion = useCallback((notif) => {
    const nueva = {
      id: Date.now(),
      timestamp: new Date().toISOString(),
      leida: false,
      ...notif,
    };
    setNotificaciones((prev) => [nueva, ...prev]);
  }, []);

  const marcarTodasLeidas = useCallback(() => {
    setUltimoVisto(Date.now());
  }, []);

  const noLeidas = notificaciones.filter(
    (n) => n.timestamp && new Date(n.timestamp).getTime() > ultimoVisto
  ).length;

  const valor = {
    notificaciones,
    agregarNotificacion,
    marcarTodasLeidas,
    noLeidas,
  };

  return <NotificacionesContext.Provider value={valor}>{children}</NotificacionesContext.Provider>;
};

export const useNotificaciones = () => useContext(NotificacionesContext);
